export default {

	pc: {
		chinese: {
			//轮播图的数组
			carouselList: [{
					imagePath: require("@/images/home/12-0new1.png")
				},
				{
					imagePath: require("@/images/home/12-1.png")
				},
				{
					imagePath: require("@/images/home/12-2.png")
				},
				{
					imagePath: require("@/images/home/12-3new1.png")
				}
			],
			//新闻数据块数组
			dataConList: [{
					txt: "注册企业",
					img: require("@/images/home/1-3.png"),
					suffix: "家",
					num: 0
				},
				{
					txt: "服务核心企业",
					img: require("@/images/home/1-5.png"),
					suffix: "家",
					num: 0
				},
				{
					txt: "服务金融机构",
					img: require("@/images/home/1-6.png"),
					suffix: "家",
					num: 0
				},
				{
					txt: "服务覆盖100+二级行业",
					img: require("@/images/home/1-4.png"),
					suffix: "类",
					num: 0
				}
			],
			// 新闻标题
			newsTit: ['公司动态', '媒体报道'],
			//查看更多
			more: 'More',
			//产品服务
			product: {
				detail:'查看详情',
				title: '产品服务',
				productList: [{
						title: "保理云",
						img: require("@/images/home/1-11.png"),
						advantage: [{
								num: "特点一",
								tit: "易流转",
								icon: require("@/images/home/1-14.png"),
								txt: "应收账款债权电子化，线上转让更便捷"
							},
							{
								num: "特点二",
								tit: "可拆分",
								icon: require("@/images/home/1-15.png"),
								txt: "可按需求拆分使用，无手续费，更灵活"
							},
							{
								num: "特点三",
								tit: "秒融资",
								icon: require("@/images/home/1-16.png"),
								txt: "直连银行系统，线上办理业务，更高效"
							},
							{
								num: "特点四",
								tit: "可追溯",
								icon: require("@/images/home/1-17.png"),
								txt: "区块链技术存证，数据可追溯，更安全"
							}
						],
						txt: "企业应收账款确认及保理融资的系统云服务，主要产品为金单。"
					},
					{
						title: "票据云",
						img: require("@/images/home/1-13.png"),
						advantage: [{
								num: "特点一",
								tit: "操作便捷",
								icon: require("@/images/home/1-34.png"),
								txt: "智能系统服务，便捷办理多家银行业务"
							},
							{
								num: "特点二",
								tit: "流通高效",
								icon: require("@/images/home/1-33.png"),
								txt: "法定票据，市场接受度高，流通性更好"
							},
							{
								num: "特点三",
								tit: "成本优势",
								icon: require("@/images/home/1-36.png"),
								txt: "用票无手续费，直通票市贴现选择更多"
							},
							{
								num: "特点四",
								tit: "风控优势",
								icon: require("@/images/home/1-35.png"),
								txt: "嵌入场景，签发需贸易背景，防控风险"
							}
						],
						txt: "企业新一代票据业务及创新的系统云服务，主要产品为供应链票据。"
					},
					{
						title: "跨境云",
						img: require("@/images/home/1-50.png"),
						advantage: [{
								num: "特点一",
								tit: "币种丰富",
								icon: require("@/images/home/1-51.png"),
								txt: "满足跨境贸易背景要求，支持不同币种"
							},
							{
								num: "特点二",
								tit: "操作简洁",
								icon: require("@/images/home/1-52.png"),
								txt: "直连银行系统，全线上操作，高效便捷"
							},
							{
								num: "特点三",
								tit: "账期无忧",
								icon: require("@/images/home/1-53.png"),
								txt: "跨境应收账款回款保障，优化现金管理"
							},
							{
								num: "特点四",
								tit: "节省成本",
								icon: require("@/images/home/1-54.png"),
								txt: "多银行线上择优选择，节省时间和成本"
							}
						],
						txt: "出口企业应收账款确认及保理融资的系统云服务，主要产品为跨境保理。"
					},
				],
			},

			//平台优势
			advantages: {
				title: '简单汇平台优势',
				details: '查看详情',
				platformList: [
					//简单汇平台优势数组
					{
						title: "创新发展优势",
						img: require("@/images/home/1-18.png"),
						txt: "从市场首创可流转应收账款电子债权凭证 “金单”，到成为全国首批接入上海票据交易所的票据基础设施单位，简单汇不断创新，业务覆盖供应链上下游全场景。"
					},
					{
						title: "科技领先优势",
						img: require("@/images/home/1-19.png"),
						txt: "简单汇率先应用区块链技术保障数据安全，引入人工智能相关技术提升运营质效，成功通过国家高新技术企业认定、CMMI3、DCMM3、双软认证，以及知识产权贯标、ISO27001、ISO9001、ISO20000、ISO27701等管理体系认证，在大数据、人工智能、区块链、生物识别、OCR等技术上取得多项发明专利及软著，与DeepSeek大模型深度技术融合，不断推动技术升级与突破。"
					},
					{
						title: "产品服务优势",
						img: require("@/images/home/1-20.png"),
						txt: "简单汇致力于提供简单温暖的客户体验，精益求精，严格项目管理，7*24全程专业服务，随时为您答疑解惑，伴随您业务发展的每一步。"
					},
					{
						title: "资金渠道优势",
						img: require("@/images/home/1-21.png"),
						txt: "简单汇首创与银行系统直连模式，与多家全国性银行和商业银行完成系统直连，并与证券、财司、保理、小贷、租赁、融担等多类型金融机构建立了稳定合作，充分发挥资金渠道优势。"
					},
					{
						title: "专业团队优势",
						img: require("@/images/home/1-22.png"),
						txt: "简单汇管理团队及核心骨干具备丰富的“金融+科技+产业”行业经验，能快速识别客户痛点，提供专业高效的服务。"
					}
				],
			},
			//合作银行
			banks: {
				title: '合作银行'
			},
			//合作企业
			enterprises: {
				title: '合作企业'
			},
			//办公地点
			location: {
				title: '业务分布'
			}
		},
		english: {
			// 英文的轮播图数组
			carouselListYW: [{
					imagePath: require("@/images/english/12-4new1.png")
				},
				{
					imagePath: require("@/images/english/12-5.png")
				},
				{
					imagePath: require("@/images/english/12-6.png")
				},
				{
					imagePath: require("@/images/english/12-7new1.png")
				}
			],
			//新闻数据块数组英文
			dataConListYW: [{
					txt: "Registered enterprises",
					img: require("@/images/home/1-3.png"),
					suffix: "",
					num: 0
				},
				{
					txt: "Anchor enterprises served",
					img: require("@/images/home/1-5.png"),
					suffix: "",
					num: 0
				},
				{
					txt: "Financial institutions served",
					img: require("@/images/home/1-6.png"),
					suffix: "",
					num: 0
				},
				{
					txt: "Sectors served ·Including 100+ secondary sectors",
					img: require("@/images/home/1-4.png"),
					suffix: "",
					num: 0
				}
			],
			// 新闻标题
			newsTit: ['Company News', 'Media Reports'],
			//查看更多
			more: 'More',
			//产品服务
			product: {
				detail:'View details',
				title: 'Product services',
				productListYW: [{
						title: "Factoring Cloud",
						img: require("@/images/home/1-11.png"),
						advantage: [{
								num: "Feature 1",
								tit: "Easy to assign",
								icon: require("@/images/home/1-14.png"),
								txt: "Electronizes accounts receivable claims, enabling more convenient online transfer"
							},
							{
								num: "Feature 2",
								tit: "Splittable",
								icon: require("@/images/home/1-15.png"),
								txt: "Can be split for use as needed, with no handling fees, offering greater flexibility"
							},
							{
								num: "Feature 3",
								tit: "Instant Financing",
								icon: require("@/images/home/1-16.png"),
								txt: "Directly connects to bank systems for online business processing, ensuring higher efficiency"
							},
							{
								num: "Feature 4",
								tit: "Traceable",
								icon: require("@/images/home/1-17.png"),
								txt: "Blockchain technology enables evidence preservation, ensuring data traceability and enhanced security"
							}
						],
						txt: 'A cloud-based service system for enterprise accounts receivable confirmation and factoring financing. Its core product is "Jin Dan".'
					},
					{
						title: "Bill Cloud",
						img: require("@/images/home/1-13.png"),
						advantage: [{
								num: "Feature 1",
								tit: "Easy to operate",
								icon: require("@/images/home/1-34.png"),
								txt: "Intelligent system services enable convenient handling of business across multiple banks"
							},
							{
								num: "Feature 2",
								tit: "Efficient circulation",
								icon: require("@/images/home/1-33.png"),
								txt: "As a statutory bill, it enjoys high market acceptance and greater liquidity"
							},
							{
								num: "Feature 3",
								tit: "Cost advantage",
								icon: require("@/images/home/1-36.png"),
								txt: "No handling fees for bill usage, with more discount options directly from the bill market"
							},
							{
								num: "Feature 4",
								tit: "Strengths in Risk Control",
								icon: require("@/images/home/1-35.png"),
								txt: "Integrated into business scenarios, requiring trade background for issuance to prevent and control risks"
							}
						],
						txt: `A cloud-based service system for enterprises' new-generation bill business and innovation. Its core product is "Supply Chain Bill".`
					},
					{
						title: "Cross-Border Cloud",
						img: require("@/images/home/1-50.png"),
						advantage: [{
								num: "Feature 1",
								tit: "A wide selection of currencies",
								icon: require("@/images/home/1-51.png"),
								txt: "Compliant with cross-border trade requirements and supporting multiple currencies"
							},
							{
								num: "Feature 2",
								tit: "Simple Operation",
								icon: require("@/images/home/1-52.png"),
								txt: "Directly connects to bank systems for full online operation, ensuring high efficiency and convenience"
							},
							{
								num: "Feature 3",
								tit: "Hassle-Free Payment Management",
								icon: require("@/images/home/1-53.png"),
								txt: "Provides protection for cross-border accounts receivable collection and optimizes cash management"
							},
							{
								num: "Feature 4",
								tit: "Cost-Effective",
								icon: require("@/images/home/1-54.png"),
								txt: "Allows online selection of optimal options from multiple banks, saving time and costs"
							}
						],
						txt: 'A cloud-based service system for export enterprise accounts receivable confirmation and factoring financing. Its core product is "Cross-Border Factoring"'
					}
				],
			},
			//平台优势
			advantages: {
				title: 'Advantages of the JDH platform',
				details: 'View details',
				platformListYW: [{
						title: "Competitive Edge in Innovation",
						img: require("@/images/home/1-18.png"),
						txt: `From pioneering the market's first transferable electronic receivable voucher "Jindan" to becoming one of China's inaugural core infrastructure participants connected to the Shanghai Commercial Paper Exchange (SHCPE), JDH drives continuous innovation and delivers end-to-end coverage across the entire supply chain ecosystem.`
					},
					{
						title: "Technological Leadership",
						img: require("@/images/home/1-19.png"),
						txt: "JDH pioneers blockchain technology for ironclad data security and deploys AI-driven solutions to enhance operational excellence. We hold National high-tech enterprise certification and triple crown certifications:Information Security & Data Governance: CMMI Level 3, DCMM Level 3, Management system certification:ISO27001、ISO9001、ISO20000、ISO27701、IP & Software: Dual-Software Accreditation,We innovations span a number of invention patents and software Copyrights in big data, artificial intelligence, blockchain, biometric identification, OCR and other technologies.Moreover, through deep technical integration with DeepSeek's large language model, we continuously drive technological breakthroughs across financial supply chains."
					},
					{
						title: "Product service advantages",
						img: require("@/images/home/1-20.png"),
						txt: "JDH is committed to delivering frictionless and customer-centric experiences, continuously striving for excellence through precision project delivery and 7*24 professional support. Our experts stand ready to resolve your inquiries, empowering every step of your business growth journey."
					},
					{
						title: "Funding Channel Advantage",
						img: require("@/images/home/1-21.png"),
						txt: "JDH pioneered the first-of-its-kind direct banking integration model, establishing system connections with multiple national and commercial banks. We maintain robust partnerships with diverse financial institutions including securities firms, finance companies, factoring providers, micro-lenders, leasing agencies, guarantee institutions and etc. This multi-layered funding ecosystem delivers unparalleled capital access capabilities."
					},
					{
						title: "Expert Team Advantage",
						img: require("@/images/home/1-22.png"),
						txt: "JDH's leadership and core talent possess extensive cross-domain expertise spanning finance, technology, and industrial sectors. This unique competency enables us to rapidly pinpoint core operational friction and deliver professionally calibrated solutions with exceptional efficiency."
					}
				],
			},
			//合作银行
			banks: {
				title: 'Cooperative banks'
			},
			//合作企业
			enterprises: {
				title: 'Cooperative enterprises'
			},
			//办公地点
			location: {
				title: 'Business Spread'
			}
		}
	},
	phone: {
		chinese: {
			//轮播图的数组
			carouselList: [{
					imagePath: require("@/images/mobile/home/carousel-1new.jpg")
				},
				{
					imagePath: require("@/images/mobile/home/carousel-2.png")
				},
				{
					imagePath: require("@/images/mobile/home/carousel-3.png")
				},
				{
					imagePath: require("@/images/mobile/home/carousel-4new.jpg")
				}
			],
			//新闻块的数据数组
			dataConList: [{
					txt: "注册企业",
					img: require("@/images/home/1-3.png"),
					suffix: "家",
					num: 0
				},
				{
					txt: "服务核心企业",
					img: require("@/images/home/1-5.png"),
					suffix: "家",
					num: 0
				},
				{
					txt: "服务金融机构",
					img: require("@/images/home/1-6.png"),
					suffix: "家",
					num: 0
				},
				{
					txt: "服务覆盖100+二级行业",
					img: require("@/images/home/1-4.png"),
					suffix: "类",
					num: 0
				}
			],
			news: {
				more: '查看更多',
				//新闻分类
				slidingList: ["公司动态", "媒体报道"],
			},
			//产品服务
			product: {
				title: '产品服务',
				productList: [{
						title: "保理云",
						img: require("@/images/mobile/home/1-9.png"),
						advantage: [{
								num: "特点一",
								tit: "易流转",
								icon: require("@/images/home/1-14.png"),
								txt: "应收账款债权电子化，线上转让更便捷"
							},
							{
								num: "特点二",
								tit: "可拆分",
								icon: require("@/images/home/1-15.png"),
								txt: "可按需求拆分使用，无手续费，更灵活"
							},
							{
								num: "特点三",
								tit: "秒融资",
								icon: require("@/images/home/1-16.png"),
								txt: "直连银行系统，线上办理业务，更高效"
							},
							{
								num: "特点四",
								tit: "可追溯",
								icon: require("@/images/home/1-17.png"),
								txt: "区块链技术存证，数据可追溯，更安全"
							}
						],
						txt: "企业应收账款确认及保理融资的系统云服务，主要产品为金单。"
					},
					{
						title: "票据云",
						img: require("@/images/mobile/home/1-10.png"),
						advantage: [{
								num: "特点一",
								tit: "操作便捷",
								icon: require("@/images/home/1-34.png"),
								txt: "智能系统服务，便捷办理多家银行业务"
							},
							{
								num: "特点二",
								tit: "流通高效",
								icon: require("@/images/home/1-33.png"),
								txt: "法定票据，市场接受度高，流通性更好"
							},
							{
								num: "特点三",
								tit: "成本优势",
								icon: require("@/images/home/1-36.png"),
								txt: "用票无手续费，直通票市贴现选择更多"
							},
							{
								num: "特点四",
								tit: "风控优势",
								icon: require("@/images/home/1-35.png"),
								txt: "嵌入场景，签发需贸易背景，防控风险"
							}
						],
						txt: "企业新一代票据业务及创新的系统云服务，主要产品为供应链票据。"
					},
					{
						title: "跨境云",
						img: require("@/images/mobile/product/hky-1.png"),
						advantage: [{
								num: "特点一",
								tit: "币种丰富",
								icon: require("@/images/mobile/product/hky-2.png"),
								txt: "满足跨境贸易背景要求，支持不同币种"
							},
							{
								num: "特点二",
								tit: "操作简洁",
								icon: require("@/images/mobile/product/hky-3.png"),
								txt: "直连银行系统，全线上操作，高效便捷"
							},
							{
								num: "特点三",
								tit: "账期无忧",
								icon: require("@/images/mobile/product/hky-4.png"),
								txt: "跨境应收账款回款保障，优化现金管理"
							},
							{
								num: "特点四",
								tit: "节省成本",
								icon: require("@/images/mobile/product/hky-5.png"),
								txt: "多银行线上择优选择，节省时间和成本"
							}
						],
						txt: "出口企业应收账款确认及保理融资的系统云服务，主要产品为跨境保理。"
					},
				],
			},
			//简单汇平台优势
			platform: {
				title: '简单汇平台优势',
				details: '查看详情',
				platformList: [{
						title: "创新发展优势",
						img: require("@/images/home/1-18.png"),
						txt: "从市场首创可流转应收账款电子债权凭证“金单”，到成为全国首批接入上海票据交易所的票据基础设施单位，简单汇不断创新，业务覆盖供应链上下游全场景。"
					},
					{
						title: "科技领先优势",
						img: require("@/images/home/1-19.png"),
						txt: "简单汇率先应用区块链技术保障数据安全，引入人工智能相关技术提升运营质效，成功通过国家高新技术企业认定、CMMI3、DCMM3、双软认证，以及知识产权贯标、ISO27001、ISO9001、ISO20000、ISO27701等管理体系认证，在大数据、人工智能、区块链、生物识别、OCR等技术上取得多项发明专利及软著，与DeepSeek大模型深度技术融合，不断推动技术升级与突破。"
					},
					{
						title: "产品服务优势",
						img: require("@/images/home/1-20.png"),
						txt: "简单汇致力于提供简单温暖的客户体验，精益求精，严格项目管理，7*24全程专业服务，随时为您答疑解惑，伴随您业务发展的每一步。"
					},
					{
						title: "资金渠道优势",
						img: require("@/images/home/1-21.png"),
						txt: "简单汇首创与银行系统直连模式，与多家全国性银行和商业银行完成系统直连，并与证券、财司、保理、小贷、租赁、融担等多类型金融机构建立了稳定合作，充分发挥资金渠道优势。"
					},
					{
						title: "专业团队优势",
						img: require("@/images/home/1-22.png"),
						txt: "简单汇管理团队及核心骨干具备丰富的“金融+科技+产业”行业经验，能快速识别客户痛点，提供专业高效的服务。"
					}
				],
			}

		},
		english: {
			// 英文的轮播图数组
			carouselListYW: [{
					imagePath: require("@/images/mobile/english/home_carousel_1new.jpg")
				},
				{
					imagePath: require("@/images/mobile/english/home_carousel_2.png")
				},
				{
					imagePath: require("@/images/mobile/english/home_carousel_3.png")
				},
				{
					imagePath: require("@/images/mobile/english/home_carousel_4new.jpg")
				}
			],
			dataConListYW: [
				//新闻数据块数组
				{
					txt: "Registered enterprises",
					img: require("@/images/home/1-3.png"),
					suffix: "",
					num: 0
				},
				{
					txt: "Anchor enterprises served",
					img: require("@/images/home/1-5.png"),
					suffix: "",
					num: 0
				},
				{
					txt: "Financial institutions served",
					img: require("@/images/home/1-6.png"),
					suffix: "",
					num: 0
				},
				{
					txt: "Sectors served ·Including 100+ secondary sectors",
					img: require("@/images/home/1-4.png"),
					suffix: "",
					num: 0
				}
			],
			//新闻分类
			news: {
				more: 'More',
				slidingListYW: ["Company News", "Media Reports"],
			},
			//产品服务
			product: {
				title: 'Product services',
				productListYW: [{
						title: "Factoring Cloud",
						img: require("@/images/mobile/home/1-9.png"),
						advantage: [{
								num: "Feature 1",
								tit: "Easy to assign",
								icon: require("@/images/home/1-14.png"),
								txt: "Electronizes accounts receivable claims, enabling more convenient online transfer"
							},
							{
								num: "Feature 2",
								tit: "Splittable",
								icon: require("@/images/home/1-15.png"),
								txt: "Can be split for use as needed, with no handling fees, offering greater flexibility"
							},
							{
								num: "Feature 3",
								tit: "Instant Financing",
								icon: require("@/images/home/1-16.png"),
								txt: "Directly connects to bank systems for online business processing, ensuring higher efficiency"
							},
							{
								num: "Feature 4",
								tit: "Traceable",
								icon: require("@/images/home/1-17.png"),
								txt: "Blockchain technology enables evidence preservation, ensuring data traceability and enhanced security"
							}
						],
						txt: 'A cloud-based service system for enterprise accounts receivable confirmation and factoring financing. Its core product is "Jin Dan".'
					},
					{
						title: "Bill Cloud",
						img: require("@/images/mobile/home/1-10.png"),
						advantage: [{
								num: "Feature 1",
								tit: "Easy to operate",
								icon: require("@/images/home/1-34.png"),
								txt: "Intelligent system services enable convenient handling of business across multiple banks"
							},
							{
								num: "Feature 2",
								tit: "Efficient circulation",
								icon: require("@/images/home/1-33.png"),
								txt: "As a statutory bill, it enjoys high market acceptance and greater liquidity"
							},
							{
								num: "Feature 3",
								tit: "Cost advantage",
								icon: require("@/images/home/1-36.png"),
								txt: "No handling fees for bill usage, with more discount options directly from the bill market"
							},
							{
								num: "Feature 4",
								tit: "Strengths in Risk Control",
								icon: require("@/images/home/1-35.png"),
								txt: "Integrated into business scenarios, requiring trade background for issuance to prevent and control risks"
							}
						],
						txt: `A cloud-based service system for enterprises' new-generation bill business and innovation. Its core product is "Supply Chain Bill".`
					},
					{
						title: "Cross-Border Cloud",
						img: require("@/images/home/1-50.png"),
						advantage: [{
								num: "Feature 1",
								tit: "A wide selection of currencies",
								icon: require("@/images/home/1-51.png"),
								txt: "Compliant with cross-border trade requirements and supporting multiple currencies"
							},
							{
								num: "Feature 2",
								tit: "Simple Operation",
								icon: require("@/images/home/1-52.png"),
								txt: "Directly connects to bank systems for full online operation, ensuring high efficiency and convenience"
							},
							{
								num: "Feature 3",
								tit: "Hassle-Free Payment Management",
								icon: require("@/images/home/1-53.png"),
								txt: "Provides protection for cross-border accounts receivable collection and optimizes cash management"
							},
							{
								num: "Feature 4",
								tit: "Cost-Effective",
								icon: require("@/images/home/1-54.png"),
								txt: "Allows online selection of optimal options from multiple banks, saving time and costs"
							}
						],
						txt: 'A cloud-based service system for export enterprise accounts receivable confirmation and factoring financing. Its core product is "Cross-Border Factoring"'
					}
				],
			},
			platform: {
				title: 'Advantages of the JDH platform',
				details: 'View details',
				platformListYW: [{
            title: "Competitive Edge in Innovation",
            img: require("@/images/home/1-18.png"),
            txt: `From pioneering the market's first transferable electronic receivable voucher "Jindan" to becoming one of China's inaugural core infrastructure participants connected to the Shanghai Commercial Paper Exchange (SHCPE), JDH drives continuous innovation and delivers end-to-end coverage across the entire supply chain ecosystem.`
          },
          {
            title: "Technological Leadership",
            img: require("@/images/home/1-19.png"),
            txt: "JDH pioneers blockchain technology for ironclad data security and deploys AI-driven solutions to enhance operational excellence. We hold National high-tech enterprise certification and triple crown certifications:Information Security & Data Governance: CMMI Level 3, DCMM Level 3, Management system certification:ISO27001、ISO9001、ISO20000、ISO27701、IP & Software: Dual-Software Accreditation,We innovations span a number of invention patents and software Copyrights in big data, artificial intelligence, blockchain, biometric identification, OCR and other technologies.Moreover, through deep technical integration with DeepSeek's large language model, we continuously drive technological breakthroughs across financial supply chains."
          },
          {
            title: "Product service advantages",
            img: require("@/images/home/1-20.png"),
            txt: "JDH is committed to delivering frictionless and customer-centric experiences, continuously striving for excellence through precision project delivery and 7*24 professional support. Our experts stand ready to resolve your inquiries, empowering every step of your business growth journey."
          },
          {
            title: "Funding Channel Advantage",
            img: require("@/images/home/1-21.png"),
            txt: "JDH pioneered the first-of-its-kind direct banking integration model, establishing system connections with multiple national and commercial banks. We maintain robust partnerships with diverse financial institutions including securities firms, finance companies, factoring providers, micro-lenders, leasing agencies, guarantee institutions and etc. This multi-layered funding ecosystem delivers unparalleled capital access capabilities."
          },
          {
            title: "Expert Team Advantage",
            img: require("@/images/home/1-22.png"),
            txt: "JDH's leadership and core talent possess extensive cross-domain expertise spanning finance, technology, and industrial sectors. This unique competency enables us to rapidly pinpoint core operational friction and deliver professionally calibrated solutions with exceptional efficiency."
          }
				],
			}

		}
	}
}



// WEBPACK FOOTER //
// ./src/utils/lang/home.js